import { parseSubtractions } from "./SaxsSubtractionsMapper";

/** Map bean data to dataCollection 
 * @return {object} dataCollection
*/
export function parseDataCollectionAsBean(data) {
    let result = {};

    if (data && data instanceof Array && data.length > 0) {
        let dataCollection = data[0];

        let parsedDataCollection = {}
        result = parsedDataCollection;
        parsedDataCollection.dataCollectionId = dataCollection.dataCollectionId

        if (dataCollection.substraction3VOs && dataCollection.substraction3VOs instanceof Array && dataCollection.substraction3VOs.length > 0) {
            let substraction3VO = dataCollection.substraction3VOs[0];

            // map subtraction
            let parsedSubtraction = {};
            parsedDataCollection.subtraction = parsedSubtraction;
            parsedSubtraction.subtractionId = substraction3VO.subtractionId;
            parsedSubtraction.bufferAverageFilePath = substraction3VO.bufferAverageFilePath;
            parsedSubtraction.sampleAverageFilePath = substraction3VO.sampleAverageFilePath;
            parsedSubtraction.subtractedFilePath = substraction3VO.substractedFilePath;

            // map buffer frames in subtraction
            parsedSubtraction.bufferFrameList = null;
            if (substraction3VO.bufferOneDimensionalFiles) {
                let bufferOneDimensionalFiles = substraction3VO.bufferOneDimensionalFiles
                let parsedBufferFrameList = {};
                parsedSubtraction.bufferFrameList = parsedBufferFrameList;
                parsedBufferFrameList.comments = bufferOneDimensionalFiles.comments;
                parsedBufferFrameList.frames = [];
                if (bufferOneDimensionalFiles.frametolist3VOs && bufferOneDimensionalFiles.frametolist3VOs instanceof Array && bufferOneDimensionalFiles.frametolist3VOs.length > 0) {
                    let frametolist3VOs = bufferOneDimensionalFiles.frametolist3VOs;

                    frametolist3VOs.forEach(frametolist3VO => {
                        if (frametolist3VO.frame3VO) {
                            let frame3VO = frametolist3VO.frame3VO;
                            let parsedFrame = {};
                            parsedFrame.comments = frame3VO.comments;
                            parsedFrame.creationDate = frame3VO.creationDate;
                            parsedFrame.filePath = frame3VO.filePath;
                            parsedFrame.frameId = frame3VO.frameId;
                            parsedBufferFrameList.frames.push(parsedFrame);
                        }
                    });
                }
            }

            // map sample frames in subtraction
            parsedSubtraction.sampleFrameList = null;

            if (substraction3VO.sampleOneDimensionalFiles) {
                let sampleOneDimensionalFiles = substraction3VO.sampleOneDimensionalFiles
                let parsedSampleFrameList = {};
                parsedSubtraction.sampleFrameList = parsedSampleFrameList;
                parsedSampleFrameList.comments = sampleOneDimensionalFiles.comments;
                parsedSampleFrameList.frames = [];
                if (sampleOneDimensionalFiles.frametolist3VOs && sampleOneDimensionalFiles.frametolist3VOs instanceof Array && sampleOneDimensionalFiles.frametolist3VOs.length > 0) {
                    let frametolist3VOs = sampleOneDimensionalFiles.frametolist3VOs;

                    frametolist3VOs.forEach(frametolist3VO => {
                        if (frametolist3VO.frame3VO) {
                            let frame3VO = frametolist3VO.frame3VO;
                            let parsedFrame = {};
                            parsedFrame.comments = frame3VO.comments;
                            parsedFrame.creationDate = frame3VO.creationDate;
                            parsedFrame.filePath = frame3VO.filePath;
                            parsedFrame.frameId = frame3VO.frameId;
                            parsedSampleFrameList.frames.push(parsedFrame);
                        }
                    });
                }
            }
        }
    }
    return result;
}


/** 
 * saxs dataset mapper 
 * */
export function parseDataCollections(subtractions) {
    let result = [];
    if (subtractions) {
        subtractions.forEach(subtraction => {
            result.push({
                bufferAcronym: subtraction.Buffer_acronym,
                bufferId: subtraction.Buffer_bufferId,
                dataCollectionId: subtraction.MeasurementToDataCollection_dataCollectionId,

                guinierAnalysis_firstPointUsed: subtraction.Subtraction_firstPointUsed,
                guinierAnalysis_I0: subtraction.Subtraction_I0,
                guinierAnalysis_I0StdDev: subtraction.Subtraction_I0Stdev,
                guinierAnalysis_lastPointUsed: subtraction.Subtraction_lastPointUsed,
                guinierAnalysis_rg: subtraction.Subtraction_rgGuinier,

                gnomAnalysis_rg: subtraction.Subtraction_rgGnom,
                gnomAnalysis_total: subtraction.Subtraction_total,
                gnomAnalysis_dmax: subtraction.Subtraction_dmax,

                measurementCode: subtraction.Measurement_code,
                measurementFlow: subtraction.Measurement_flow,
                measurementTransmission: subtraction.Measurement_transmission,
                measurementVolumeToLoad: subtraction.Measurement_volumeToLoad,
                measurementWaitTime: subtraction.Measurement_waitTime,
                measurementViscosity: subtraction.Measurement_viscosity,

                merge_averageFilePath: subtraction.Merge_averageFilePath,
                merge_id: subtraction.Merge_mergeId,

                macromoleculeName: subtraction.Macromolecule_name,
                macromoleculeAcronym: subtraction.Macromolecule_acronym,
                macromoleculeId: subtraction.Macromolecule_macromoleculeId,

                porodAnalysis_volume: subtraction.Subtraction_volume,

                run_exposureTemperature: subtraction.Run_exposureTemperature,
                runId: subtraction.Run_runId,
                run_mergedFrameCount: subtraction.Merge_framesMerge,
                run_totalFrameCount: subtraction.Merge_framesCount,

                samplePlate_slotPositionColumn: subtraction.SamplePlate_slotPositionColumn, // position of the plate on the deck: 1,2,3
                samplePlatePosition_columnNumber: subtraction.SamplePlatePosition_columnNumber,
                samplePlatePosition_rowNumber: subtraction.SamplePlatePosition_rowNumber,

                specimenConcentration: subtraction.Specimen_concentration,
                specimenVolume: subtraction.Specimen_volume,
                specimenId: subtraction.Specimen_specimenId,

                subtractionId: subtraction.Subtraction_subtractionId,
                subtraction_sampleAverageFilePath: subtraction.Subtraction_sampleAverageFilePath,
                subtraction_abInitioId: subtraction.SubtractionToAbInitioModel_abinitioId,

                fit: subtraction.fit,
                superposition: subtraction.superposition,
                rigidBody: subtraction.rigidBody
            })
        });
        return result;
    }
    return null;
}


// WEBPACK FOOTER //
// ./src/helpers/Saxs/SaxsDataCollectionMapper.js